import * as React from "react";
import type { SVGProps } from "react";
const AccountingFirm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4362_3073)">
      <path
        fill="currentColor"
        d="M7 0C5.3453 0 4 1.3453 4 3v18c0 1.6547 1.3453 3 3 3h12c1.6547 0 3-1.3453 3-3V3c0-1.6547-1.3453-3-3-3zm1.5 3h9c.8297 0 1.5.6703 1.5 1.5V6c0 .8297-.6703 1.5-1.5 1.5h-9C7.6703 7.5 7 6.8297 7 6V4.5C7 3.6703 7.6703 3 8.5 3m1.5 7.5a1.5001 1.5001 0 0 1-2.5607 1.0607A1.5001 1.5001 0 0 1 8.5 9a1.5 1.5 0 0 1 1.5 1.5m-1.5 6a1.5 1.5 0 1 1-.0001-3 1.5 1.5 0 0 1 .0001 3m-1.5 3c0-.8297.6703-1.5 1.5-1.5H13c.8297 0 1.5.6703 1.5 1.5S13.8297 21 13 21H8.5c-.8297 0-1.5-.6703-1.5-1.5m6-7.5a1.5001 1.5001 0 1 1 0-3.0002A1.5001 1.5001 0 0 1 13 12m1.5 3a1.5001 1.5001 0 1 1-3.0002 0A1.5001 1.5001 0 0 1 14.5 15m3-3a1.5001 1.5001 0 1 1 0-3.0002A1.5001 1.5001 0 0 1 17.5 12m1.5 3a1.5001 1.5001 0 1 1-3.0002 0A1.5001 1.5001 0 0 1 19 15m-1.5 6a1.5001 1.5001 0 1 1 0-3.0002A1.5001 1.5001 0 0 1 17.5 21"
      />
    </g>
    <defs>
      <clipPath id="clip0_4362_3073">
        <path fill="transparent" d="M4 0h18v24H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default AccountingFirm;
